import { StepperItem } from "views/eshop/order/components/stepper";

export function getStatusSteps(): StepperItem[] {
  return [
    {
      number: 1,
      label: "license",
    },
    {
      number: 2,
      label: "fuel",
    },
    {
      number: 3,
      label: "charge",
    },
    {
      number: 4,
      label: "contact",
    },
    {
      number: 5,
      label: "recap",
    },
  ];
}
